export const content = {
  title: 'Wirklich verwerfen & umplanen?',
  closeDialogAriaLabel: 'Dialog schließen',
  mainText: 'Wenn keiner der Vorschläge passt, kannst du diese verwerfen und in die Umplanung gehen.',
  hint: 'Verworfene Vorschläge können nicht wiederhergestellt werden.',
  cancelButton: 'Nein, doch nicht',
  approveButton: 'Ja, verwerfen & umplanen',
} as const;
